import { Sheet } from "@amzn/storm-ui";
import React from "react";
import { useStore } from "zustand";

import { insightDetailComponentStore } from "../../../../store/insightDetailComponent";
import type {
    InsightDetailOption,
    InsightDetailProps,
} from "../../../../utils/insightDetail.utils";
import { InsightDetailType } from "../../../../utils/insightDetail.utils";

import {
    StyledDetailSheetPDFViewerContainer,
    StyledInsightSheetBody,
    StyledInsightSheetHeader,
    StyledSheetFooter,
} from "./styles";

const InsightDetailComponentViewer: React.FunctionComponent<{
    insightDetailOption: InsightDetailOption;
    props: InsightDetailProps;
}> = ({ insightDetailOption, props }) => {
    const { type, component: Component } = insightDetailOption;
    switch (type) {
        case InsightDetailType.VIEW:
            return <Component />;
        case InsightDetailType.SELECTION:
            return (
                <Component
                    selectedSlides={props.selectedSlides}
                    setSelectedSlides={props.setSelectedSlides}
                />
            );
    }
};

export const InsightDetailSheet: React.FunctionComponent = () => {
    const [open, onMount, onClose, headerOption, bodyOption, footerOption] =
        useStore(insightDetailComponentStore, (state) => [
            state.open,
            state.onMount,
            state.onClose,
            state.headerOption,
            state.bodyOption,
            state.footerOption,
        ]);

    const [selectedSlides, setSelectedSlides] = React.useState(
        new Set<number>(),
    );

    const allInsightDetailProps: InsightDetailProps = {
        selectedSlides,
        setSelectedSlides,
    };

    React.useEffect(() => {
        open && onMount && onMount(allInsightDetailProps);
    }, [open, onMount]);

    const handleClose = () => {
        onClose && onClose();
    };

    return (
        <div data-testid="insight-detail-sheet-container">
            <Sheet
                sheetElementId="ihub-portal"
                padding={"none"}
                data-testid={`insight-detail-sheet`}
                isOpen={open}
                onClose={() => void handleClose()}
                side="end"
                closeButton={{
                    type: "icon",
                    label: "",
                }}
            >
                <StyledInsightSheetBody>
                    <StyledInsightSheetHeader>
                        <InsightDetailComponentViewer
                            insightDetailOption={headerOption}
                            props={allInsightDetailProps}
                        />
                    </StyledInsightSheetHeader>
                    <StyledDetailSheetPDFViewerContainer>
                        <InsightDetailComponentViewer
                            insightDetailOption={bodyOption}
                            props={allInsightDetailProps}
                        />
                    </StyledDetailSheetPDFViewerContainer>
                    <StyledSheetFooter>
                        <InsightDetailComponentViewer
                            insightDetailOption={footerOption}
                            props={allInsightDetailProps}
                        />
                    </StyledSheetFooter>
                </StyledInsightSheetBody>
            </Sheet>
        </div>
    );
};
